import { useMemo } from "react";
import { useSearchParams } from "react-router";

import { getSortOptionFromURI } from "components/Filters/helpers";

import { PersonalApiKey } from "../gql";
import { PERSONAL_API_KEYS_INITIAL_SORT } from "./constants";
import { sortPersonalApiKeys } from "./sort";

const usePersonalApiKeysSort = (apiKeys: PersonalApiKey[]) => {
  const [searchParams] = useSearchParams();

  const orderBy = useMemo(
    () =>
      getSortOptionFromURI(
        searchParams,
        PERSONAL_API_KEYS_INITIAL_SORT.field,
        PERSONAL_API_KEYS_INITIAL_SORT.direction
      )[0] ?? PERSONAL_API_KEYS_INITIAL_SORT,
    [searchParams]
  );

  return useMemo(() => sortPersonalApiKeys(apiKeys, orderBy), [apiKeys, orderBy]);
};

export default usePersonalApiKeysSort;
